import { getCookie, setCookie } from "../utils/Utils";

class BannerCookiesClass {
  constructor() {
    this.main = document.getElementById('banner_cookies');
    this._acceptBtn = this.main.querySelector('.btn_accept');

    this._isOpen = false;
    this._acceptBtn.addEventListener('click', this._acceptCookies.bind(this));

    if(getCookie('bannerCookiesAccepted') != 1) {
      this.show();
    }
  }

  show() {
    this._isOpen = true;

    this.main.classList.add('banner-cookies--show');
  }

  hide() {
    if (this._isOpen) {
      this._isOpen = false;

      this.main.classList.remove('banner-cookies--show');
    }
  }

  get isOpen() {
    return this._isOpen;
  }

  _acceptCookies(e) {
    e.preventDefault();
    e.stopPropagation();

    this._isOpen = false;

    this.main.classList.remove('banner-cookies--show');

    setCookie('bannerCookiesAccepted', 1, 365);
  }
}

const BannerCookies = new BannerCookiesClass();

Object.seal(BannerCookies);

export default BannerCookies;
